module.exports = __webpack_public_path__ + "images/vehicle-state-icon.2215fa44b31221c5a5070ded40c8dd74.png";